export interface DomainStatus {
    active: boolean;
    parked?: boolean | null;
}

export const getDomainStatusDotClass = (domain: DomainStatus): string => {
    if (domain.parked === true) {
        return "bg-gray-400";
    }

    if (domain.active === true) {
        return "bg-green-500";
    }

    return "bg-orange-500";
};

export const getDomainStatusBadgeClass = (domain: DomainStatus): string => {
    if (domain.parked === true) {
        return "policy-badge badge-parked";
    }

    if (domain.active === true) {
        return "policy-badge badge-active";
    }

    return "policy-badge badge-inactive";
};

export const getDomainStatusTranslationKey = (domain: DomainStatus): string => {
    if (domain.parked === true) {
        return "vue.parked";
    }

    if (domain.active === true) {
        return "vue.active";
    }

    return "vue.inactive";
};
